import fromFormat from "./fromFormat";

export default function fromDDMMYYYY(x: string) {
  return fromFormat(x, "dd/MM/yyyy");
}
